var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
const StyledTabs = styled(Tabs) `
    width: 100%;
    min-height: 60px;
    background: #26262c;

    & .MuiTabs-indicator {
        background-color: #8980ef;
    }
`;
export const SidebarTabs = (props) => {
    const tabsProps = __rest(props, []);
    return _jsx(StyledTabs, Object.assign({ centered: true }, tabsProps));
};
